"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tex2SVG = exports.useTexSVG = exports.MathJaxProvider = void 0;
const react_1 = __importStar(require("react"));
const MathJaxContext = react_1.createContext({});
exports.MathJaxProvider = ({ options = {}, children = null, }) => {
    const ref = react_1.useRef(null);
    const [mathJax, setMathJax] = react_1.useState(window.MathJax || options);
    react_1.useEffect(() => {
        const existingScript = document.getElementById("mathjax-script");
        if (existingScript) {
            const onLoad = existingScript.onload;
            existingScript.onload = () => {
                onLoad();
                setMathJax(window.MathJax);
            };
        }
        if (!existingScript && !window.MathJax) {
            const script = document.createElement("script");
            window.MathJax = mathJax;
            script.id = "mathjax-script";
            script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
            script.async = true;
            script.onload = () => setMathJax(window.MathJax);
            document.head.appendChild(script);
        }
        return () => { };
    });
    return (react_1.default.createElement(MathJaxContext.Provider, { value: mathJax },
        react_1.default.createElement("span", { ref: ref }),
        children));
};
function useTexSVG({ latex = "", onSuccess = (html) => { }, onError = (html) => { }, } = {}) {
    const mathJax = react_1.useContext(MathJaxContext) || null;
    const [html, setHtml] = react_1.useState(null);
    const [isLoading, setIsLoading] = react_1.useState(false);
    const error = !!(html === null || html === void 0 ? void 0 : html.outerHTML.match(/data-mjx-error/));
    react_1.useEffect(() => {
        function setMathJaxHTML() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const isReady = (mathJax === null || mathJax === void 0 ? void 0 : mathJax.tex2svgPromise) || (yield ((_b = (_a = mathJax === null || mathJax === void 0 ? void 0 : mathJax.loader) === null || _a === void 0 ? void 0 : _a.ready) === null || _b === void 0 ? void 0 : _b.call(_a)));
                if (isReady) {
                    try {
                        setIsLoading(true);
                        const mathJaxElement = yield mathJax.tex2svgPromise(latex);
                        setHtml(mathJaxElement);
                    }
                    catch (e) {
                        console.error("Something went really wrong, if this problem persists then please open an issue", e);
                    }
                    finally {
                        setIsLoading(false);
                    }
                }
            });
        }
        setMathJaxHTML();
    }, [mathJax, latex]);
    react_1.useEffect(() => {
        if (html && error)
            onError(html);
        if (html && !error)
            onSuccess(html);
    }, [html]);
    return [html, { error, isLoading }];
}
exports.useTexSVG = useTexSVG;
exports.Tex2SVG = (_a) => {
    var { latex = "", onError = (html) => { }, onSuccess = (html) => { } } = _a, props = __rest(_a, ["latex", "onError", "onSuccess"]);
    const ref = react_1.useRef(null);
    const [html, { error }] = useTexSVG({ latex, onError, onSuccess });
    react_1.useEffect(() => {
        var _a;
        if (html && !error) {
            Object.keys(props).map((key) => html.setAttribute(key, props[key]));
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.appendChild(html);
            return () => {
                var _a;
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeChild(html);
            };
        }
        return () => { };
    }, [props, html]);
    return react_1.default.createElement("span", { ref: ref });
};
const Tex2SVGWithProvider = (props) => (react_1.default.createElement(exports.MathJaxProvider, null,
    react_1.default.createElement(exports.Tex2SVG, Object.assign({}, props))));
exports.default = Tex2SVGWithProvider;
